const promiseMap = new Map();

/**
 * To those whom are dedicated async programmers this must confuse you. Well this exists purely for
 * compatibility with systems that don't support async fns or promise returns in general. So we take
 * in the promise and attach the resolution to a done var. The aforementioned variable is in a closure
 * by a returned isReady function so that when the synchronous function checks it will recieve a value
 * it can understand.
 *
 * @template {T}
 * @param {Promise<T>} promiseToWrap - Promise to wrap poll around for analytics library
 */
export function pollPromiseWrapper<T>(promiseToWrap: Promise<T>) {
  const promiseId = window.crypto.randomUUID();
  let done = false;
  let data;
  let error;

  promiseMap.set(promiseId, promiseToWrap);
  promiseToWrap
    .then((result) => {
      if (result !== undefined) {
        data = result;
        promiseMap.delete(promiseId);
      }
      done = true;
    })
    .catch((e) => {
      error = e;
      promiseMap.delete(promiseId);
    });

  return {
    promise: promiseToWrap,
    isReady: () => {
      if (done) {
        return true;
      } else if (error !== undefined) {
        throw error.error !== undefined ? error.error : error;
      }
    },
  };
}

export function loadScript(url: string) {
  const scriptPromise = new Promise<void>((res, rej) => {
    const scriptElement = document.createElement("script");
    scriptElement.async = true;
    scriptElement.src = url;
    scriptElement.addEventListener("load", () => {
      res();
    });
    scriptElement.addEventListener("error", (e) => {
      rej(e);
    });
    document.head.appendChild(scriptElement);
  });

  return pollPromiseWrapper(scriptPromise);
}
